import { render, staticRenderFns } from "./touch.vue?vue&type=template&id=2d01a786&scoped=true&"
import script from "./touch.vue?vue&type=script&lang=js&"
export * from "./touch.vue?vue&type=script&lang=js&"
import style0 from "./touch.vue?vue&type=style&index=0&id=2d01a786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01a786",
  null
  
)

export default component.exports